<template>
  <div class="detail-page reverse">
    <div class="detail-page__left">
      <CardLeftBlock
          class="clear-992"
          :backgroundImage="'product-admin'"
      >
        <template slot="body">
          <UserInfo/>
        </template>
      </CardLeftBlock>
    </div>

    <div class="detail-page__right">
      <CardRightBlock>
        <template slot="header">
          <div class="order-create__head">
            <div class="order-create__head-line">
              <div class="order-create__header-col">
                <router-link :to="$store.getters.GET_PATHS.mainSettingsHSCodes" class="detail-page__head-back">
                  <LinkBack
                          :value="$t('ex_backTo.localization_value.value')"
                  />
                </router-link>
              </div>
            </div>
            <div class="order-create__head-title"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate([
                          'menu_hSCodes',
                        ])"></div>
              {{$t('menu_hSCodes.localization_value.value')}}
            </div>
          </div>
        </template>

        <template slot="body">
          <StepA
              :HSCode="HSCode"
          />
        </template>
        <template slot="footer">
          <div class="order-create__footer">
            <div class="order-create__footer-link">
              <router-link :to="$store.getters.GET_PATHS.mainSettingsHSCodes"
                           class="site-link site-link--alt"
              >
                {{$t('common_cancel.localization_value.value')}}
              </router-link>

            </div>

            <div class="order-create__footer-btn ml-auto"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate([
                          'common_create',
                        ])"></div>

              <MainButton
                  class="order-create__footer-btn-i wfc"
                  :value="$t('common_create.localization_value.value')"
                  @click.native="$emit('createHSGroup')"
                  v-bind:class="{'disabled-btn' : $store.getters.getNewPaymentsBtn}"
              />

            </div>
          </div>
        </template>
      </CardRightBlock>
    </div>

  </div>
</template>

<script>
  import MainButton from "../../../../../UI/buttons/MainButton/MainButton";
  import CardLeftBlock from "../../../../../coreComponents/CardLeftBlock/CardLeftBlock.vue";
  import UserInfo from "./components/UserInfo/UserInfo";
  import CardRightBlock from "../../../../../coreComponents/CardRightBlock/CardRightBlock.vue";
  import LinkBack from "../../../../../UI/buttons/LinkBack/LinkBack";
  import StepA from "@/components/modules/HSCodesModule/components/chunks/StepA/StepA";

  export default {
    name: "HSCodeCreateAdmin",
    components: {
      StepA,
      MainButton,
      CardLeftBlock,
      UserInfo,
      CardRightBlock,
      LinkBack,
    },

    props: {
      HSCode: Object,
      serverError: Boolean,
    },

    data(){
      return{
        comment: '',
      }
    },

    methods:{

    },

  }
</script>

<style scoped>

</style>
